module.exports = __webpack_public_path__ + "static/media/oops.c7ac00a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/img/oops.svg
// module id = 1180
// module chunks = 21